var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.954407,
    width: 30,
    height: 29.3157,
    fill: "url(#pattern0_291_332)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_291_332",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_291_332",
    transform: "matrix(0.0108577 0 0 0.0111111 0.0114045 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_291_332",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC9UlEQVR4nO2aPWsVQRSGn2gQQQSNggELLWxsBFEEK220MpWdH42ldjb+AC1SWFhYKAgKamWllWlMJYhpbGxUVLAQFAJK0CgxRxb2NpK7O7s7u3PGvA8cCOTuxzycOzvz3gUhhBBCCCGEEEIIIYQQQggRl23Ac8BUVDlYAHZ2lb0FmJNoxkmeB7bG6WvYBDySbP6V/ATY3EboRMX/NgJ3JZuR5HvAZEuX3A84+LpkcxPYUNOUd6pEh34drqxj2bMNptlK0aET/EXgj4OB20C1ClxuuHCoFR26ZDkD/HYgwXquFeBCjYvtayyFg0QX9RrYXXOBU8APBzKsp1oGTtc4mAZerXFssOiiPgD7ai50DPjmQIpFriXgRM3Y9wJvxxzfSHRRn4EDNRc8BHx1IMci1SJwtGbM+4FPFedoLDrWhS2TCmmswwGN1Ur06Kt0MuCr9MaBLGtZIVPl8cCpsrXoon4FPBx2jXk4mPMKefjPAD8Dz9dJdOhyJ7fk72XAcvZsw+VsZ9FNFvBPHUisq5AN2qUWG7QoottsSc1h9Rk5RBXdJGQxZ9V3iBZd9BA3bZFriOboRXROyd/sQNNdb6K9J3+rLRI4t6K9Jn8rLRM416K9JX/LHRI496K9JH9LHRO4LESnTv4WEwdhg4q2RAOOlcBlJdoCk789kZK/9xETuOxE20DJX+wELkvR1nPy10cCl61o6yn5e9ZTApe1aIu8FX7sdOvvRrQBNwLe+btdcfyt8jPjmCivYetdtAW8MDh6gBUZxJey5sqdZRWT5blTjcudaOvyCqzjHxxciraIL3V7eXnerWgDXgBTHSRPledIPQ73og34CBxpIfkg8M7B/Wcj2sqd29XA7t4BXBtot/ffibayvgMPgHNlSDRdVvH3eeBh+ZnU95m9aMu4JBqJJnUXqqNJL05TB+mlao5Gokndcepo0kvS1EF6gZqj8VXasCDRpO5CdTTpxWnqIL1UzdE4FC2EEEIIIYQQQgghhBBCCCGo4S88Bh70wRw8ngAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.bef7ac54a5b0b5c84e5ee6ea876084a8.svg";
export { ForwardRef as ReactComponent };